// import Firebase from 'firebase'
//
let config = {
  apiKey: "AIzaSyAEArfmRYATEaxJby5QXYYa8rzpsqwBlvI",
  authDomain: "ashioto-315.firebaseapp.com",
  databaseURL: "https://ashioto-315.firebaseio.com",
  projectId: "ashioto-315",
  storageBucket: "ashioto-315.appspot.com",
  messagingSenderId: "1036074966598",
  appId: "1:1036074966598:web:b6829603178e47c08ff447",
  measurementId: "G-3WPCDJLZZQ"
}
// let firebaseApp = Firebase.initializeApp(config)
// Firebase.analytics()
// let db = firebaseApp.database()
// export default db


import firebase from 'firebase'
import firebaseApp from 'firebase/app'
import 'firebase/database'

// export const db = firebase
//   .initializeApp({ databaseURL: 'MY PROJECT URL' })
//   .database()

let fa = firebaseApp.initializeApp(config)
firebase.analytics()
export const db = fa.database()
// export const apiKey = 'AIzaSyBpsR-w2kvp2yDrMGrS_PzLeaZucq7ol8s'
